const OPENCAGE_API_KEY = "36e23feaa1ee4764b903e8ad824a8541"; // Tu API Key real

const geocodeCache = {}; // Caché en memoria para evitar múltiples llamadas

export async function getCoordinatesFromAddress(address) {
    if (!address) return null;

    const fullAddress = `${address}, España`; // 👉 Añade país
    console.log("📤 Geocodificando:", fullAddress); // 🧪 Debug

    // Revisa localStorage
    const cached = localStorage.getItem(`coords:${fullAddress}`);
    if (cached) return JSON.parse(cached);

    // Revisa caché en memoria
    if (geocodeCache[fullAddress]) return geocodeCache[fullAddress];

    const url = `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(fullAddress)}&key=${OPENCAGE_API_KEY}`;

    const response = await fetch(url);
    const data = await response.json();

    if (data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry;
        const coords = { lat, lng };

        // Guarda en caché
        geocodeCache[fullAddress] = coords;
        localStorage.setItem(`coords:${fullAddress}`, JSON.stringify(coords));

        return coords;
    } else {
        console.warn(`❌ No se pudo geocodificar: ${fullAddress}`);
        return null;
    }
}
